
import { Component, Vue } from 'vue-property-decorator';

import Form19ProcessHeader from "@/components/process/Form19/components/Form19ProcessHeader.vue";
import { form19StatusInfoType } from '@/types/Information/Form19';

@Component({
    components:{
        Form19ProcessHeader
    }
})
export default class CancelSubmitForm19 extends Vue {

    stepsCompleted = {} as form19StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
